
<div *ngIf="totalRegistros > 0">
  <div class="ui-g barraTotalOrdem">
    <div class="ui-g-6">
      <p-message severity="info" text="Total registros: {{totalRegistros}}"></p-message>
    </div>
    <div class="ui-g-6 barraOrdem">
      <p-dropdown [options]="ordenacoes" [(ngModel)]="ordem" (onChange)="aplicarOrdenacao($event)"></p-dropdown>
    </div>
  </div>

  <div class="ui-g list-anuncios d-flex">
    <reuse-anuncio-item-novo *ngFor="let anuncio of anuncios" [anuncio]="anuncio" [origem]="MEUS_ANUNCIOS_GOVERNO" (liberarFinalizarAnuncio)="showModalLiberarFinalizar($event)" (alterarTipoAnuncio)="abrirModalAlterarTipoAnuncio($event)" ></reuse-anuncio-item-novo>
  </div>

  <p-paginator [rows]="tamanhoPagina" [totalRecords]="totalRegistros" (onPageChange)="paginar($event)"
    [(first)]="inicio"></p-paginator>
</div>

<div *ngIf="carregouDados && totalRegistros == 0">
  <p-message severity="warn" text="Nenhum registro encontrado."></p-message>
</div>

<reuse-liberar-anuncio #liberarFinalizarAnuncio ></reuse-liberar-anuncio>
<alterar-tipo-anuncio #alterarTipoAnuncio [show]="true" ></alterar-tipo-anuncio>
